export const navBarMenu = {
  'products': [
    {
      name: 'Products',
      url: '/product/all',
      lookup: '/product/all',
    },
    {
      name: 'Variants',
      url: '/variant/all', 
      lookup: 'variant/all',
    },
    {
      name: 'OOS Editor',
      url: '/variant-bulk-editor',
      lookup: 'variant-bulk-editor',
    },
    {
      name: 'Parcels',
      url: '/parcels',
      lookup: '/parcels', 
    }
  ],
  
  'supply-chain': [
    {
      name: 'Overview',
      url: '/po-overview',
      lookup: 'overview',
    },
    {
      name: 'Containers',
      url: '/containers',
      lookup: 'container',
    },
    {
      name: 'Releases',
      url: '/releases',
      lookup: 'releases',
    },
    {
      name: 'Purchase Orders',
      url: '/purchase-order',
      lookup: 'purchase-order',
    },
    {
      name: 'Factories',
      url: '/factories',
      lookup: 'factories',
    },
  ],
  'notifications' :[
    {
      name: 'Inbox',
      url: '/notifications/inbox',
      lookup: 'notifications/inbox',
    },
    {
      name: 'Read',
      url: '/notifications/read',
      lookup: 'notifications/read',
    }
    
  ],
  'fulfillment-location' :[
    {
      permission: 'AirboxPersonalisation',
      name: 'Airbox Personalisation',
      url: '/fulfillment/locations/airbox',
      lookup: '/fulfillment/locations/airbox',
    },
    {
      permission: 'ViewOrders',
      name: 'EWE Personalisation',
      url: '/fulfillment/locations/ewe',
      lookup: '/fulfillment/locations/ewe',
    },
    {
      permission: 'ViewOrders',
      name: 'EWESYD Personalisation',
      url: '/fulfillment/locations/sydewe',
      lookup: '/fulfillment/locations/sydewe',
    },
    {
      permission: 'LaunchPersonalisation',
      name: 'Launch Personalisation',
      url: '/fulfillment/locations/launch',
      lookup: '/fulfillment/locations/launch',
    },
    {

      permission: 'UNISPersonalisation',
      name: 'UNIS Personalisation',
      url: '/fulfillment/locations/unis',
      lookup: '/fulfillment/locations/unis',
    },
  ],

  // tickets/warranty
  'tickets' :[
    {
      name: 'Warranty Tickets',
      url: '/tickets/warranty',
      lookup: '/tickets/warranty',
    },
    {
      name: 'Order Tickets',
      url: '/tickets/order',
      lookup: '/tickets/order',
    },
    {
      name: 'Repair Tickets',
      url: '/tickets/repair',
      lookup: '/tickets/repair',
    },
    {
      name: 'Ticket Export',
      url: '/tickets/export',
      lookup: '/tickets/export',
    },
   
  ],
  
  // order-report
  'order-report' :[
    {
      name: 'Mispick Report',
      url: '/order-report/mispick',
      lookup: '/order-report/mispick',
    },
    {
      name: 'Order Cycle Time',
      url: '/order-report/cycle-time',
      lookup: '/order-report/cycle-time',
    },
    {
      name: 'Nested Order Rate',
      url: '/order-report/nested-rate',
      lookup: '/order-report/nested-rate',
    },
  ]
};
